export default {
  PAGE_TITLE: "Questionnaire completed",
  ANSWER_CONTENT: "Response content",
  THANK_YOU_ANSWER: "Thank you for your cooperation \nwith the survey.",
};
